import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import {parseError} from '../utils/helper';
import Steps, { Step } from 'rc-steps';
import './LotteryBanner.scss';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import GENERIC_ERROR_MESSAGE from '../Constants';
import RightArrow from '../img/LotteryBanner/arrow-right.png';
import {getWalletData} from '../utils/helper';

export default function LotteryBanner(props) {

    const [lotteryStep, setLotteryStep] = React.useState(1);
    const [lotteryResultStatus, setLotteryResultStatus] = React.useState(); // lottery RESULT can be 0,1,2
    const [showLotteryModel, setShowLotteryModel] = React.useState(false);
    const [showLotteryJotform, setShowLotteryJotform] = React.useState(false);
    const [currentStepLottery, setCurrentStepLottery] = React.useState(0);
    

    const toggleBackdrop = () => {
        document.body.classList.toggle('remove-backdrop');
    };

    React.useEffect(() => {
        if (props.walletAddress) {
            getWalletData(props.walletAddress).then((data) => {
                setLotteryResultStatus(data.status);
                setLotteryStep(2)
            }, (error) => {
                console.log('error', error);
                // TODO: remove these after demo
                setLotteryResultStatus(1);
                setLotteryStep(2)
            });
        }
    }, [props.walletAddress])

    // React.useEffect(() => {
    //     if(props.selectedWallet) {
    //         setStatus().then(() => setCurrentStepLottery(1)); 
    //     }
    // }, [props.createAssociatedTokenAccountForSolr])

    const Iframe = (props) => {
        return (
            <div>
                <iframe title={props.src} src={props.src} width="100%" />
            </div>
        );
    };

    return (
        <div className="lottery-main">
            <div className="lottery-layout">
                <div className="container">
                <Row className={`lottery-desktop-view ${ lotteryResultStatus === 1 && 'lottery-won-bg-img'}`}>
                    {/* lottery landing */}
                    {lotteryStep === 1 && (
                        <>
                            <Col>
                                <div className="lottery-title-div">
                                    <div className="lottery-title">Lottery Draw Results</div>
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <div className="lottery-content-step-1">
                                        <h1 className="lottery-content">
                                            Connect your Solana wallet to check if you won the lottery
                                        </h1>
                                    </div>
                                    <div className="lottery-connect-btn-div">
                                        <Button 
                                            onClick={() => {
                                                props.connectToWallet();   
                                            }
                                            } 
                                            className="lottry-connect-btn btn-lin-grad lottery-shine btn-transform"
                                            >
                                            Connect Wallet
                                            <span className="hover-show"><img src={RightArrow} alt="right-arrow" /></span>
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </>
                    )}

                    {/* lottery step 2 start from here or lottery RESULT */}
                    {lotteryStep === 2 && (
                        <>
                            {/* lottery not won / you lose */}
                            {lotteryResultStatus === 0 && (                        
                                <Col>
                                    <div>
                                        <div className="lottery-won">
                                            <h1 className="lottery-status">Uh Oh!!</h1>
                                        </div>
                                        <div className="lottery-won">
                                            <h1 className="lotter-status-sub-text">Unfortunately you were not selected in the public sale lottery</h1>
                                        </div>
                                        <div className="lottery-won">
                                            <p className="lottery-status-thk-msg">Thank you for joining our whitelist!</p>
                                        </div>
                                    </div>
                                </Col>
                            )}

                            {/* lottery won */}
                            {lotteryResultStatus === 1 && (
                                <>
                                    <Col>
                                        <div className="lottery-title-div">
                                            <div className="lottery-title">You Won the Lottery</div>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div>
                                            <div className="lottery-stepper-align">
                                                <div className="lottery-stepper">
                                                    <Steps current={currentStepLottery} direction="horizontal">
                                                        <Steps.Step className="step-1" />
                                                        <Steps.Step className="step-2" />
                                                    </Steps>
                                                </div>
                                            </div>
                                            
                                            {currentStepLottery === 0 && (
                                                <>
                                                    <div className="lottery-won">
                                                        <h1 className="lottery-won-sub-text">Click on the button below to approve<br /> SOLR in your wallet.</h1>
                                                    </div>
                                                    <div className="lottery-connect-btn-div lottery-step-btn">
                                                        <Button 
                                                            disabled={!props.walletAddress}
                                                            onClick={() => {
                                                                props.createAssociatedTokenAccountForSolr(props.selectedWallet).then((data) => {
                                                                    console.log(data);
                                                                    setCurrentStepLottery(1);
                                                                }, (error) => {
                                                                    const isGenericError = parseError(error.message) === GENERIC_ERROR_MESSAGE;
                                                                    
                                                                    if(isGenericError && error.message.indexOf('account Address') !== -1 && error.message.indexOf('already in use') !== -1 ) {
                                                                        console.log('Wallet already approved!')
                                                                        setCurrentStepLottery(1);
                                                                    } else {
                                                                        console.log(error); // TODO do UI treatment
                                                                    }
                                                                });
                                                            }}
                                                            className="lottry-connect-btn btn-lin-grad btn-transform"
                                                            >
                                                            Approve SOLR
                                                        </Button>
                                                    </div>
                                                </>
                                            )}

                                            {currentStepLottery === 1 && (
                                                <>
                                                    <div className="lottery-won">
                                                        <h1 className="lottery-won-sub-text">Please provide valid information<br /> below for KYC</h1>
                                                    </div>
                                                    <div className="lottery-connect-btn-div">
                                                        <Button 
                                                            onClick={() => {
                                                                setShowLotteryModel(true);
                                                                setShowLotteryJotform(true);
                                                            }}
                                                            className="lottry-connect-btn btn-lin-grad btn-transform"
                                                            >
                                                            Open KYC Form
                                                        </Button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </Col>
                                </>
                            )}
                            
                            {/* lottery  waiting list */}
                            {lotteryResultStatus === 2 && (
                                <>
                                    <Col>
                                        <div className="lottery-title-div">
                                            <div className="lottery-title">You are on the Waitlist</div>
                                        </div>
                                    </Col>
                                    <Col>
                                         <div>
                                            <div className="lottery-stepper-align">
                                                <div className="lottery-stepper">
                                                    <Steps current={currentStepLottery} direction="horizontal">
                                                        <Steps.Step className="step-1" />
                                                        <Steps.Step className="step-2" />
                                                    </Steps>
                                                </div>
                                            </div>
                                                
                                            {currentStepLottery === 0 && (
                                                <>
                                                    <div className="lottery-won">
                                                        <h1 className="lottery-won-sub-text">Click on the button below to approve<br /> SOLR in your wallet.</h1>
                                                    </div>
                                                    <div className="lottery-connect-btn-div">
                                                        <Button 
                                                            // disabled={!props.walletAddress}
                                                            onClick={() => {
                                                                props.createAssociatedTokenAccountForSolr(props.selectedWallet).then((data) => {
                                                                    console.log(data);
                                                                    setCurrentStepLottery(1);
                                                                });
                                                            }}
                                                            className="lottry-connect-btn btn-lin-grad btn-transform"
                                                            >
                                                            Approve SOLR
                                                        </Button>
                                                    </div>
                                                </>
                                            )}

                                            {currentStepLottery === 1 && (
                                                <>
                                                    <div className="lottery-won">
                                                        <h1 className="lottery-won-sub-text">Please provide valid information<br /> below for KYC</h1>
                                                    </div>
                                                    <div className="lottery-connect-btn-div">
                                                        <Button 
                                                            onClick={() => {
                                                                setShowLotteryModel(true);
                                                                setShowLotteryJotform(true);
                                                            }}
                                                            className="lottry-connect-btn btn-lin-grad btn-transform"
                                                            >
                                                            Open KYC Form
                                                        </Button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </Col>
                                </>
                            )}  
                        </>
                    )}
                </Row>

                {/* Lottery MOBILE view */}
                <Row className="lottery-mobile-view">
                    <div className="text-center">
                        Lottery results is
                        supported only on Desktop
                    </div>
                </Row>
                </div>
            </div>

            {/* Lottery modal start */}                                    
            <>
                <Modal
                    show={showLotteryModel}
                    size="lg"
                    onHide={() => setShowLotteryModel(false)}
                    dialogClassName="modal-90w"
                    animation={false}
                    className="whitelist-modal"
                    aria-labelledby="example-custom-modal-styling-title">
                    <Modal.Header closeButton onClick={toggleBackdrop} />
                    <Modal.Body>
                        <div className="whitelist-frame">
                            {showLotteryJotform ? (
                                <Iframe src={`https://form.jotform.com/211570761499463?yourSolana39=${props.walletAddress}`} />
                            ) : null}
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        </div>
    )
}
